/**
 * @type {{unknown_list_type: string, sample_order: string, shopping_list: string, watchlist: string, cart: string}}
 */
const pilsTypes = {
    cart: 'cart',
    shopping_list: 'shopping_list',
    watchlist: 'watchlist',
    sample_order: 'sample_order',
    unknown_list_type: 'unknown_list_type'
};

export default pilsTypes;
